module.exports = __webpack_public_path__ + "img/listview-editjob.24cf8620.svg";